import { configurePlayerXhr } from './playerTransport';
var XMLHttpRequest = require('xhr2');

const util = {
    
   getJSON(url, callback) {
        var xhr = new XMLHttpRequest();
        configurePlayerXhr(xhr, 'GET', url);
        xhr.responseType = 'json';
        xhr.onload = function() {
          var status = xhr.status;
          if (status === 200) {
            callback(null, xhr.response);
          } else {
            callback(status, xhr.response);
          }
        };
        xhr.onerror = function() {
          const error = { error: 'Can not communicate with service', status: xhr.status || 0 };
          callback(xhr.status || 0, error);
        };
        xhr.send();
        return xhr;
    },

    putJSON(url, data, callback) {
        console.log("putJSON: " + url)
        var xhr = new XMLHttpRequest();
        configurePlayerXhr(xhr, 'POST', url);
        xhr.responseType = 'json';
        xhr.onload = function() {
          var status = xhr.status;
          if (status === 200) {
            callback(null, xhr.response);
          } else {
            callback(status, xhr.response);
          }
        };
        xhr.onerror = function() {
          const error = { error: 'Can not communicate with service', status: xhr.status || 0 };
          callback(xhr.status || 0, error);
        };
        const localOffset = new Date().getTimezoneOffset();  //get now in current time zone time
        const timezone = Intl.DateTimeFormat('en-US').resolvedOptions().timeZone
       if (Array.isArray(data)) {
          console.log(data)
          for (let element of data) {
            element.timezoneOffset = localOffset
            element.timezone = timezone
          }
       }
       else {
         data.timezoneOffset = localOffset
         data.timezone = timezone
       }
       xhr.send(JSON.stringify(data));
       return xhr;
    },

    putJSONtoGetBlob(url, data, callback) {
        console.log("putJSON: " + url);
        const xhr = new XMLHttpRequest();
        configurePlayerXhr(xhr, 'POST', url);
        xhr.responseType = 'blob'; // Set responseType to 'blob'
        xhr.onload = function () {
          const status = xhr.status;
          if (status === 200) {
            callback(null, xhr.response); // xhr.response will now be a Blob
          } else {
            callback(status, xhr.response);
          }
        };
        xhr.onerror = function () {
          const error = { error: 'Cannot communicate with service', status: xhr.status || 0 };
          callback(xhr.status || 0, error);
        };
        const localOffset = new Date().getTimezoneOffset(); // Get now in current time zone
        const timezone = Intl.DateTimeFormat('en-US').resolvedOptions().timeZone;
        if (Array.isArray(data)) {
          console.log(data);
          for (let element of data) {
            element.timezoneOffset = localOffset;
            element.timezone = timezone;
          }
        } else {
          data.timezoneOffset = localOffset;
          data.timezone = timezone;
        }
        xhr.send(JSON.stringify(data));
        return xhr;
      },
      
    putFile(url, data, cbUploading, cbComplete) {
      var xhr = new XMLHttpRequest();
      configurePlayerXhr(xhr, 'POST', url);
      xhr.responseType = 'json';
      xhr.onload = function() {
        var status = xhr.status;
        if (status === 200) {
          cbComplete(null, xhr.response);
        } else {
          cbComplete(status, xhr.response);
        }
      };
      xhr.onerror = function() {
        cbComplete(xhr.status || 0, { error: 'Can not communicate with service', status: xhr.status || 0 });
     };
     xhr.send(data);
     return xhr;
  }
    
}

export default util;
        
